import { Navigate, useSearchParams } from 'react-router-dom';
import LoginPage from '../../pages/LoginPage';
import { useAuthStore } from '../../store/authStore';
import { safeNextPath } from '../../lib/safeNext';
import { afterLoginPath } from '../../lib/twoFactor';

/**
 * Pot `/login` (T2519).
 *
 * Prijavljenemu je pot prej vedno izrisala `<Navigate to="/dashboard">`. Ker
 * `login(user)` stanje seje zamenja sinhrono, se je ta preusmeritev izrisala
 * med prijavo samo in povozila `navigate(nextPath)` iz `LoginPage` — uporabnik,
 * ki je prišel z vabila (`/login?next=/accept-invite/…`) ali s tržnice (T1224),
 * je pristal na nadzorni plošči. Zdaj preusmeritev upošteva isti varen `next`
 * kot prijavna stran; nevaren ali manjkajoč `next` vodi na
 * `DEFAULT_AFTER_LOGIN` (T2529 — ista konstanta kot obrazec).
 *
 * T2959: in isto obvezno nastavitev 2FA — sicer je ta preusmeritev sysadmina
 * brez 2FA z nastavitve (`finishLogin`) vrnila na `/dashboard`.
 */
const LoginRoute = () => {
  const { isAuthenticated, user } = useAuthStore();
  const [searchParams] = useSearchParams();
  if (!isAuthenticated) return <LoginPage />;
  return <Navigate to={afterLoginPath(user, safeNextPath(searchParams.get('next')))} replace />;
};

export default LoginRoute;
